module.exports = __webpack_public_path__ + "img/welcome.c472dd35.png";